'use client';

import { SearchEngine } from '@coveo/atomic-react';
import { ReactNode, createContext, useContext } from 'react';

const EngineContext = createContext<SearchEngine | null>(null);

export function EngineProvider({
  engine,
  children,
}: {
  engine: SearchEngine;
  children: ReactNode;
}) {
  return (
    <EngineContext.Provider value={engine}>{children}</EngineContext.Provider>
  );
}

/**
 * Returns the Coveo SearchEngine instance provided by the nearest EngineProvider.
 * Use this instead of importing `engine()` directly so components work with
 * both the search engine (SearchV2Page) and the listing engine (ListingPage).
 */
export function useEngine(): SearchEngine {
  const eng = useContext(EngineContext);
  if (!eng) {
    throw new Error('useEngine must be used within an EngineProvider');
  }
  return eng;
}
